import { connect } from "react-redux";
import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import * as Yup from "yup";

import Button from "../UI/Button";
import CardHeading from "../UI/Headings/CardHeading";
import { CustomForm } from "../../component-library/CustomForm";
import FormikInput from "../UI/FormikInput";
import { setAuthAfterPasswordReset } from "../../redux/actions/auth";
import { yup_password_factory } from "../../utils/yupSchemaUtils";

import { AuthWrapper } from "./index";

const validation = Yup.object().shape({
  confirm_password: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("new_password"), null], "Password does not match"),
  current_password: yup_password_factory(),
  new_password: yup_password_factory(),
});

const PwResetRequired = (props) => {
  useEffect(() => {
    if (!props.auth.token) {
      props.history.push("/auth/log-in");
    }
  }, []);

  let setNewPasswordHandler = (form, actions) => {
    delete form.confirm_password;
    const { accessToken, refreshToken, token } = props.auth;
    let cleanResponse = {
      AuthenticationResult: {
        AccessToken: accessToken,
        IdToken: token,
        RefreshToken: refreshToken,
      },
    };

    props.setAuthAfterPasswordReset(form, props.auth.accessToken, cleanResponse);
    actions.setSubmitting(false);
  };

  const forgotPassword = () => {
    props.history.push("/auth/forgot-password");
  };

  return (
    <AuthWrapper showBackLink={true}>
      <section className="ResetPassword">
        <CardHeading className="fs-20 patient-profile-purple" text="Change Password" />
        We noticed that your password hasn't been updated for the past 90 days. Please reset your
        password to continue.
        <hr className="my-2" />
        <CustomForm
          initialValues={{ confirm_password: "", current_password: "", new_password: "" }}
          onSubmit={setNewPasswordHandler}
          render={(formikProps) => (
            <form onSubmit={formikProps.handleSubmit}>
              <FormikInput
                errors={formikProps.errors}
                formEl={{
                  elementConfig: {
                    label: "Current Password",
                    placeholder: "Enter Current Password",
                    type: "password",
                  },
                  elementType: "input",
                  name: "current_password",
                }}
                touched={formikProps.touched}
              />
              <FormikInput
                errors={formikProps.errors}
                formEl={{
                  elementConfig: {
                    label: "New Password",
                    placeholder: "Enter New Password",
                    type: "password",
                  },
                  elementType: "input",
                  name: "new_password",
                }}
                touched={formikProps.touched}
              />
              <FormikInput
                errors={formikProps.errors}
                formEl={{
                  elementConfig: {
                    label: "Confirm New Password",
                    placeholder: "Confirm New Password",
                    type: "password",
                  },
                  elementType: "input",
                  name: "confirm_password",
                }}
                touched={formikProps.touched}
              />
              <div className="d-flex justify-content-end">
                <Button
                  className="Btn Btn-link txt-sec"
                  onClick={forgotPassword}
                  style={{ margin: 0 }}
                  type="button"
                >
                  <b>Forgot Password?</b>
                </Button>
              </div>
              <div className="d-flex justify-content-end">
                <>
                  <Button
                    className="Btn Btn--pri Btn-sm mt-2"
                    disabled={formikProps.isSubmitting}
                    type="submit"
                  >
                    Confirm
                  </Button>
                  <a
                    className="Btn Btn--otl-pri Btn-sm mt-2 ml-2"
                    onClick={() => props.history.push("/auth/sign-in")}
                    style={{ cursor: "pointer", textAlign: "center" }}
                  >
                    Cancel
                  </a>
                </>
              </div>
            </form>
          )}
          validationSchema={validation}
        />
      </section>
    </AuthWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, { setAuthAfterPasswordReset })(withRouter(PwResetRequired));
